import React from 'react';
import _ from 'lodash';

class NumberWidgetSettings extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            widget: props.widget,
        };
    }

    componentWillReceiveProps(props) {
        this.setState({
            widget: props.widget,
        });
    }

    render() {
        return (
            <div>
                <div className="displaySettings-row">
                    <span className="title">Budget</span>
                    <input
                        className="form-control"
                        type="text"
                        placeholder="Hämta från Upsales"
                        value={_.get(this.state.widget, 'displayConfig.budget', '')}
                        onChange={(event) => {
                            this.props.setWidgetFieldValue(
                                'displayConfig.budget',
                                parseInt(event.target.value, 10) || null,
                            );
                        }}
                    />
                </div>
            </div>
        );
    }
}

NumberWidgetSettings.propTypes = {
    setWidgetFieldValue: React.PropTypes.func,
    widget: React.PropTypes.object,
};

export default NumberWidgetSettings;



/** WEBPACK FOOTER **
 ** ./client/components/SettingsModal/DisplaySettings/NumberWidgetSettings.jsx
 **/